"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPsychicItemTypeV1 = void 0;
var IPsychicItemTypeV1;
(function (IPsychicItemTypeV1) {
    IPsychicItemTypeV1["ScheduledWorkout"] = "ScheduledWorkout";
    IPsychicItemTypeV1["LiveScheduledWorkout"] = "LiveScheduledWorkout";
    IPsychicItemTypeV1["ContinueSeriesWorkout"] = "ContinueSeriesWorkout";
    IPsychicItemTypeV1["StaffPickWorkout"] = "StaffPickWorkout";
    IPsychicItemTypeV1["UpNextChallenge"] = "UpNextChallenge";
})(IPsychicItemTypeV1 || (exports.IPsychicItemTypeV1 = IPsychicItemTypeV1 = {}));
//# sourceMappingURL=psychic-item-type-v1.js.map